import { CLEAR_SINGLE_CATEGORY_FILE, FETCH_SINGLE_CATEGORY_FILE, SET_SINGLE_CATEGORY_FILE } from "../actions";

const initialState = {
    singlecategoryData: null,
    isLoading: false,
    error: null,
};

const singleCollectionCategoryFileReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_SINGLE_CATEGORY_FILE:
            return { ...state, isLoading: true, error: null };

        case SET_SINGLE_CATEGORY_FILE:
            return { ...state, singlecategoryData: action.payload, isLoading: false, error: null };

        case CLEAR_SINGLE_CATEGORY_FILE:
            return { ...state, singlecategoryData: null, isLoading: false, error: null };

        default:
            return state;
    }
};

export default singleCollectionCategoryFileReducer;
